import { useEffect, useRef, useState } from 'react';
import { ExamsResultHooksProps, IconStatusProps } from './ExamsResult.types';

const statusEnums = {
	finished: {
		color: '#8dc63f',
		message: 'Resultados recibidos',
		pixelCorrection: 0,
	},
	partial: {
		color: '#4f82c2',
		message: 'Resultados parciales',
		pixelCorrection: 0,
	},
	pendingResult: {
		color: '#d8dee6',
		message: 'Sin resultados',
		pixelCorrection: -20,
	},
};

export const useExamsResult = ({ exams }: ExamsResultHooksProps) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [resultAmount, setResultAmount] = useState('0');
	const [status, setStatus] = useState<IconStatusProps>('pendingResult');
	const [visible, setVisible] = useState(false);
	const [position, setPosition] = useState({ x: 0, y: 0 });

	const handleHover = (state: boolean) => {
		if (!containerRef.current) return;

		const { x, y } = containerRef.current.getBoundingClientRect();
		setPosition({ x, y });
		setVisible(state);
	};

	const getStatus = (): IconStatusProps => {
		if (!exams.length) return 'pendingResult';

		const finished = exams.filter((exam) => exam.status === 'finished').length;

		if (finished === exams.length) return 'finished';

		if (finished > 0) return 'partial';

		return 'pendingResult';
	};

	const getResultAmount = () => {
		const total = exams.length;
		const finished = exams.filter((exam) => exam.status === 'finished').length;

		return `${finished} de ${total}`;
	};

	useEffect(() => {
		setStatus(getStatus());
		setResultAmount(getResultAmount());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		status,
		visible,
		position,
		statusEnums,
		resultAmount,
		containerRef,
		handleHover,
	};
};
